import React from 'react';
import { isMobile } from '@gamiphy/utils/device';

export const useMobile = (): boolean => React.useMemo(() => isMobile(), []);
